<ng-template cellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
    <div>
        <div class="contentDiv" (click)="toggle(rowIndex)">{{dataItem | property:field}}
            <fui-action>
                <fui-icon *ngIf="getInfoValue(dataItem)" [height]="15" [icon]="'information'" [width]="20"></fui-icon>
            </fui-action>
        </div>
        <wbo-info-text-pop [popped]="isOpen(rowIndex)" (popped$)="poppedChange($event, rowIndex)"><span class="info">{{getInfoValue(dataItem)}}</span></wbo-info-text-pop>
    </div>
</ng-template>
